export default function RecommendationCategoriesController(
  $filter,
  $rootScope,
  $scope,
  $timeout,
  alerts,
  amDataService,
  amSharedModelService,
  editRecommendationCategoryDialog,
  loaderService,
  ssDialogService,
) {
  const vm = this;

  // Attach Event Handlers
  vm.handleExpandRecommendationCategories = _handleExpandRecommendationCategories;
  vm.handleAddRecommendationCategory = _handleAddRecommendationCategory;
  vm.handleGeneratePackage = _handleGeneratePackage;
  vm.handleDownloadPackage = _handleDownloadPackage;
  vm.handleImportedRecommendationCategories = _handleImportedRecommendationCategories;
  vm.refreshRecommendationCategories = _refreshRecommendationCategories;

  _init();

  /** **********************************************
   * Event Handlers
   */

  function _handleExpandRecommendationCategories() {
    if (!vm.isExpanded) {
      _loadRecommendationCategories().then(() => {
        vm.isExpanded = true;
      });
    } else {
      vm.isExpanded = false;
    }
  }

  function _handleImportedRecommendationCategories() {
    // TODO: importDocumentDialog should return recommendationCategories model collection, then append instead of fetch
    _loadRecommendationCategories(true);
  }

  function _handleAddRecommendationCategory($event) {
    ssDialogService.dialogs.auditTrail.editRecommendationCategoryDialog = ssDialogService.alert(
      editRecommendationCategoryDialog.getOptions($event, {
        customerId: vm.customerId,
        recommendationCategory: {
          auditId: vm.auditId,
          recommendationCategoryId: 0,
        },
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.auditTrail.editRecommendationCategoryDialog);
  }

  /*
  function _handleCreatePackageFileList($event) {
    return amDataService.generateRecommendationPackageFileList(vm.auditId).then(function (response) {
      alerts.success('The Recommendation Package File List has been successfully generated. '+
      'Please run the Audit Package File List Report to view the results.');
    });
  }
  */

  function _handleGeneratePackage() {
    return amDataService.createRecommendationPackageFileGenerationRequest(vm.auditId).then(() => {
      alerts.success('The Recommendation Package has been successfully requested. '
        + 'You will receive an email notification when the file generation is complete.');
      vm.hasAuditPackageGenerationRequests = true;
    });
  }

  function _handleDownloadPackage() {
    alerts.success('Download Package has been requested. Package download will start momentarily.');
    amDataService.downloadPackage(vm.auditPackageId).then((packageResponse) => {
      amDataService.download(packageResponse);
    });
  }

  function _refreshRecommendationCategories() {
    _loadRecommendationCategories(true);
  }

  /** **********************************************
   * Private Functions
   */

  function _init() {
    vm.canExpand = true;
    vm.isExpanded = false;
    vm.hasData = false;
    vm.canEditItem = vm.canEdit && vm.auditIsActive;
    vm.canDeleteItem = vm.canDelete && vm.auditIsActive;
    vm.canGenerateItemPackage = vm.canGeneratePackage && vm.auditIsActive;
    vm.canDownloadItemPackage = vm.canDownloadPackage && vm.hasActiveAuditPackage;
    _initEventListeners();
  }

  function _initEventListeners() {
    $scope.$on('refreshAMRecommendationCategories', (event, opt) => {
      if (opt.auditId === vm.auditId) {
        _loadRecommendationCategories(true);
      }
    });
  }

  function _setNoItemMessage() {
    if (vm.recommendationCategories.length === 0) {
      vm.noItemMessage = 'There are currently no Recommendations for you to contribute to in this Audit.';
    } else {
      vm.noItemMessage = 'There are no Recommendations yet. Please import or add Recommendations.';
    }
  }

  function _loadRecommendationCategories(forceRefresh = false) {
    loaderService.showViewLoader = true;
    return amSharedModelService.getRecommendationCategories(vm.auditId, forceRefresh)
      .then((recommendationCategories) => {
        loaderService.showViewLoader = false;
        vm.recommendationCategories = recommendationCategories;
        _setNoItemMessage();
      });
  }
}

RecommendationCategoriesController.$inject = [
  '$filter',
  '$rootScope',
  '$scope',
  '$timeout',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'editRecommendationCategoryDialog',
  'loaderService',
  'ssDialogService',
];
